import React from 'react'
import { useLocation } from 'react-router-dom'
import Routes from '../../data/routes'
import useConfirmationActions from '../../data/useConfirmationActions'

import { useHeaderMeQuery } from '../../graphql'
import HeaderComponent from './HeaderComponent'

const Header = () => {
  const { data, error } = useHeaderMeQuery()
  const { goBackToWebsite, goToMyProfile } = useConfirmationActions()

  const location = useLocation()
  const isConfirmationPage = location.pathname === Routes.CONFIRMATION

  if (error) {
    throw new Error(error.message)
  }

  const username = data?.me?.firstName
  const avatar = data?.me?.profilePicture?.xSmall

  if (isConfirmationPage) {
    return (
      <HeaderComponent
        username={username}
        avatar={avatar}
        goBackToWebsite={goBackToWebsite}
        goToMyProfile={goToMyProfile}
      />
    )
  }

  return <HeaderComponent username={username} avatar={avatar} />
}

export default Header
